import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllWorkflowTags } from '../../../services/qc/workflowTagsService';
import { getApiErrorMessage } from '../../../utils/apiErrorMessage';

/**
 * Loads global workflows + all tags after auth (see `WorkflowTagsProvider`).
 */
export const fetchWorkflowTagsBootstrap = createAsyncThunk(
  'workflowTags/fetchBootstrap',
  async (_, { rejectWithValue }) => {
    try {
      return await fetchAllWorkflowTags();
    } catch (e) {
      return rejectWithValue(
        getApiErrorMessage(e, 'Failed to load workflow tags'),
      );
    }
  },
);
